import React from 'react';
import CommunicationLogic from './CommunicationLogic';
import {Layout, Tabs, Card} from 'antd';
import appColors from '../../style/theme';
import {ApartmentOutlined} from '@ant-design/icons';
const {Content} = Layout;
const items_ = [
  {label: <Card
    style={{
      width: 200,
      height: '25.5vh',
      background: appColors['ColorA'],
      marginLeft: '3vh',
    }}
    cover={
      <ApartmentOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: 'white'}}/>
    }bordered={false}
    hoverable={true}
  >
    <p style={{background: 'transparent', fontSize: '2vh', marginTop: '-2vh', color: 'white'}}><b>Communication</b></p>
  </Card>, key: 'one', children: <CommunicationLogic/>},
];

const CommunicationPage = () => {
  return (
    <Layout style={{background: 'transparent'}}>
      <Content>
        <Tabs
          centered='true'
          defaultActiveKey="1"
          type="line"
          items={items_}
          size='small'
          tabBarGutter='-1vh'
        />
      </Content>
    </Layout>
  );
};

export default CommunicationPage;
